import React from 'react'
import { logger } from '../logging'

import { View, Text, Flex, Button } from '@aws-amplify/ui-react'

export default function ErrorBanner({ error, setError }: { error: any, setError: any }) {
    logger.error("An error occured", JSON.stringify(error))
    // Axios error handling:
    // https://axios-http.com/docs/handling_errors
    let errorMsg
    try {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // The actual error message should be in the error field of the response
            // If it's not there, let's transform it to an internal error message
            errorMsg = error.response.data?.error || 'Internal Error -- Contact Us'
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            if (error.code === 'ERR_NETWORK') {
                // This could be a 401 permission issue due to CORS or any other thing
                errorMsg = error.message
            } else {
                // Anything else
                errorMsg = error.request
            }
        } else {
            // Something happened in setting up the request that triggered an Error
            errorMsg = `Client-side error: ${JSON.stringify(error.message)}`
        }
    } catch (e) {
        errorMsg = `Internal Error: ${JSON.stringify(error)}`
    }
    if (typeof errorMsg !== 'string') {
        errorMsg = JSON.stringify(errorMsg)
    }

    logger.debug("Error message", errorMsg)
    return (
        <View backgroundColor='red.10' className="error-banner">
            <Flex justifyContent='center' alignItems='center' direction='row'>
                <Text>{errorMsg}</Text> <Button onClick={() => setError()}>Dismiss</Button>
            </Flex>
        </View>
    )
}
